<template>
  <nav class="nav-secondary">
    <ul class="menu">
      <li class="menu-item">
        <router-link :to="{ name: 'consulting' }">Consulting</router-link>
      </li>
      <li class="menu-item">
        <a href="https://decisiondeskhq.com/privacy-policy/">Privacy Policy</a>
      </li>
      <li :key="$auth.authenticated" class="menu-item" v-if="!$auth.authenticated">
        <router-link :to="{ name: 'login' }">Login</router-link>
      </li>
      <li :key="$auth.authenticated" class="menu-item" v-else>
        <a href="/" @click="logout">Logout</a>
      </li>
    </ul>
  </nav>
</template>

<script>
const name = 'nav_secondary'

const methods = {
  logout () {
    this.$auth.logout()
    if ((this.$route.meta || {}).auth === true) {
      this.$router.push('/')
    }
  }
}

export default {
  name,
  methods
}
</script>



// WEBPACK FOOTER //
// src/components/layout/BottomNavSecondary.vue